import React, {FunctionComponent, useEffect, useState} from 'react';
import './AppHeader.scss';
import ImpersonificationCorner from '../../common/ImpersonificationCorner/ImpersonificationCorner';

import InactivityPopUp from '../InactivityPopup/InactivityPopup'
import useAmplifyAuth from '../../../helpers/useAmplifyAuth';
import {useSelector} from 'react-redux';
import Menu from '../../Menu/Menu';

interface AppHeaderProps {
  handleSignOut: Function;
  user: any;
}

const AppHeader: FunctionComponent<AppHeaderProps> = (props) => {
  const {
    state: {user},
  } = useAmplifyAuth();

  const isActiveImpersonification: any = useSelector((state: any) => state.auth.impersonationActive);
  const impersonateProfile: any = useSelector((state: any) => state.auth.profileImpersonate);

  const [sessionIsAboutToExpire, setExpiration] = useState(false);

  const calculateInactvity = () => {
    const expirationDate: any = localStorage.getItem('session_expires_in');
    const currentHour = new Date().getTime();
    const minutesLeftToExpiration = ((expirationDate - currentHour) / 1000) / 60;
    // console.log('minutesLeftToExpiration',Math.round(minutesLeftToExpiration));
    if (
      Math.round(minutesLeftToExpiration) < 11 && Math.round(minutesLeftToExpiration) > 0
    ) {
      setExpiration(true)
    }
  }

  useEffect(() => {
    calculateInactvity()

    const interval = setInterval(() => {
      calculateInactvity()
    }, 300000);
    return () => clearInterval(interval);
  }, [])

  const refreshed = () => {
    const expirationDate = new Date().getTime() + (60 * 60 * 1000);
    localStorage.setItem('session_expires_in', String(expirationDate));
    setExpiration(false);
  }

  return <div className="AppHeader" data-testid="AppHeader">

    {user && <InactivityPopUp refreshed={refreshed} visible={sessionIsAboutToExpire}/>}

    <Menu/>

    {isActiveImpersonification && <ImpersonificationCorner impersonateProfile={impersonateProfile}/>}

  </div>
};

export default AppHeader;
